import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-po-info-banner',
  templateUrl: './po-info-banner.component.html',
  styleUrls: ['./po-info-banner.component.scss'],
})
export class PoInfoBannerComponent {
  @Input() message = '';
  @Input() background = '';
  @Input() iconColor = '';
}
